import React, { useState, useEffect } from 'react';
import { makeStyles, Button } from "@material-ui/core";
import { connect } from 'react-redux';
import { useRef } from 'react';

export const Timer = (props) => {
    const classes = useStyles();

    const [duration, setDuration] = useState(null)
    const [timers, setTimers] = useState([])
    const isInitialMount = useRef(true);

    useEffect(() => {
        if (props.line) {
            if (props.workstationState.updatedWorkstationId === props.line.id) {
                resetTimers()
                props.refresh()

            }
            if (isInitialMount.current) {
                isInitialMount.current = false;
            } else {

            }
        }
    }, [props.workstationState.workstationsWithScissorStatusInfo]);

    function resetTimers() {

        var i;
        for (i = 0; i < timers.length; i++) {
            clearInterval(timers[i])
        }
        if (timers.length > 0) {
            setTimers([])
        }
    }

    useEffect(() => {
        let mounted = true

        if (mounted) {
            let tempTimers = []

            if (timers.length > 0) {
                resetTimers()
            }
            tempTimers.push(setInterval(() => setElapsedTime(), 1000))

            setTimers(tempTimers)

        }

        return function cleanup() {

            mounted = false
        }
    }, [props.startTime]);

    function setElapsedTime() {
        var diff = (new Date() - new Date(props.startTime))
        msToTime(diff)
    }

    function msToTime(s) {

        function pad(number) {
            if (number < 10) {
                return number = "0" + String(number)
            }
            else {
                return number = String(number)
            }
        }

        var ms = s % 1000;
        s = (s - ms) / 1000;
        var secs = s % 60;
        s = (s - secs) / 60;
        var mins = s % 60;
        s = (s - mins) / 60
        var hrs = s % 24;
        s = (s - hrs) / 24

        if (hrs > 0) {
            setDuration(pad(hrs) + ':' + pad(mins) + ':' + pad(secs));
        }
        else {
            setDuration(pad(mins) + ':' + pad(secs))
        }
    }

    return <div>{duration}</div>
}

const useStyles = makeStyles({

});

function mapStateToProps(state) {
    return {
        workstationState: state.workstationState
    }
}

export default connect(mapStateToProps)(Timer)